//import { post, put } from "axios";
import axios from 'axios';
import { getApiAsyn, baseUrl, getApiAsynarrayBuffer, deleteApi, getAuthHeaders } from "../../../PostAPI";
import { handleAPIError, APIError } from "../../../common/errorHandler";
import { API_URL } from "../../../../utils/constant";
import { extractData } from "../../../../utils";
import { getDecoratedUrl } from "../../../common/urlService";



const { post, put, get } = axios;
export const fetchRentersRegisteredRenters = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.RENTERS_REGISTEREDRENTERS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRentersRegisteredRentersDropdown = async (payload) => {
  const url = API_URL.RENTERS_REGISTEREDRENTERS.DROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result; //extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};



export const multipartDataUploadImage = (url, payload) => {
 
  const formPayload = new FormData();
  formPayload.append("file", payload?.file[0]);
  const config = {
    headers: {
      ...getAuthHeaders(localStorage.getItem("token")),
      "Content-Type": "multipart/form-data",
    },
  };
  return post(baseUrl + url, formPayload, config);
};



export const upladImageData = async (payload) => {
  const url = API_URL.UPLOAD_IMAGE.replace(
    ":id",
    payload.id
  );
  try {
    let result = await multipartDataUploadImage(
      url,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };

  if (isEdit) {
    return post(baseUrl + url, data, config);
  } else {
    return post(baseUrl + url, data, config);
  }
};
export const createRentersRegisteredRenters = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RENTERS_REGISTEREDRENTERS.CREATE}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const editRentersRegisteredRenters = async (payload) => {
  const url = API_URL.RENTERS_REGISTEREDRENTERS.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};





const dataExportApi = (url, data) => {
  const config = {
    headers: getAuthHeaders(localStorage.getItem("token")),
  };
    return get(baseUrl + url, data, config);
};

export const exportRentersRegisteredRentersRecord = async (payload) => {
  const url = API_URL.RENTERS_REGISTEREDRENTERS.EXPORT;
  try {
    let result = await getApiAsynarrayBuffer(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};




export const fetchRentersRegisteredRentersById = async (payload) => {
  const url = API_URL.RENTERS_REGISTEREDRENTERS.GET_BY_ID.replace(
    ":id",
    payload?.id
  );
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchRentersRegisteredRentersViewById = async (payload) => {
  console.log("RES", payload)
  // const url = API_URL.RENTERS_REGISTEREDRENTERS.VIEW_BY_ID.replace(
  //   ":id",
  //   payload?.id
  // );


  const url = getDecoratedUrl({
    url: API_URL.RENTERS_REGISTEREDRENTERS.VIEW_BY_ID,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const deleteRentersRegisteredRenters = async (payload) => {
  try {
     const url = API_URL.RENTERS_REGISTEREDRENTERS.DELETE.replace(
      ":id",
      payload?.id
    );

      let result = await deleteApi(url, localStorage.getItem("token"));
    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
}; 



export const updatePaymentStatus = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RENTERS_REGISTEREDRENTERS.UPDATE_PAYMENT}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const updateCancellationStatus = async (payload) => {
  try {
    let result = await dataUploadApi(
      `${API_URL.RENTERS_REGISTEREDRENTERS.UPDATE_CANCILATION}`,
      payload
    );

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};
